module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-277.840b352.woff2";